import { createContext } from 'react';

// True for the server render of a landing page and for the browser's first
// (hydration) render of that HTML; false everywhere else, including every
// editor preview and the client-only SPA path.
//
// Components that would otherwise start in a client-only state read it in their
// state initializers, so the hydration render matches the server markup exactly.
// Reveal is the reason it exists: the SPA starts below-the-fold sections hidden
// and fades them in; a pre-rendered page must start them visible (that is what
// the HTML shows) and only hide the ones still off screen after hydration.
export const SsrContext = createContext(false);

// The page's own origin (https://host) on a server-rendered page, so URLs built
// from it (the booking embed) come out the same on the server and in the
// browser. Null everywhere else; callers then use window.location.origin.
export const PageOriginContext = createContext<string | null>(null);
